/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Legend_PartialInputs */

const en_ui_laps_legend_partial = /** @type {(inputs: Ui_Laps_Legend_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`partial`)
};

const de_ui_laps_legend_partial = /** @type {(inputs: Ui_Laps_Legend_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilstück`)
};

/**
* | output |
* | --- |
* | "partial" |
*
* @param {Ui_Laps_Legend_PartialInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_legend_partial = /** @type {((inputs?: Ui_Laps_Legend_PartialInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Legend_PartialInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_legend_partial(inputs)
	return de_ui_laps_legend_partial(inputs)
});